module.exports = "/_next/static/files/1ddb676810e0455cced35548761faa69.svg";